import { yupResolver } from '@hookform/resolvers/yup';
import { IonBackButton, IonButton, IonButtons, IonCol, IonContent, IonHeader, IonIcon, IonItem, IonRow, IonTitle, IonToolbar } from '@ionic/react';
import { build, person } from 'ionicons/icons';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { logTransaction } from '../../common/log';
import FormInput from '../../components/form/formInput/FormInput';
import { LogType } from '../../models/log.model';
import { RouteNames } from '../../models/routes.model';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { addAdhocRepairOrderToRepairOrderSyncStoreAsync } from '../../store/repairOrderSyncSlice';
import { IonPageWrapper } from './AdhocClockingPage.styles';
import { IAdhocJob } from '../../models/dms/adhocJob.model';

interface IComponentProps {}

interface IFormInputs extends IAdhocJob {
  customerName: string;
  repairOrderNumber: number | undefined;
  registrationNumber: string;
  vehicleDetails: string;
  vin: string;
}

const schema = yup.object().shape({
  customerName: yup.string().required('provide a customer name'),
});

const AdhocClockingPage: React.FC<IComponentProps> = () => {
  let submitButtonRef: HTMLButtonElement | null = null;

  const history = useHistory();
  const dispatch = useAppDispatch();

  const { isDemo } = useAppSelector((state) => state.app);

  useEffect(() => {
    if (isDemo) {
      setValue('customerName', 'Naomi Smith');
      setValue('repairOrderNumber', 899481);
      setValue('registrationNumber', '000-000');
      setValue('vehicleDetails', '2017 Nissan X-trail St');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { control, handleSubmit, setValue } = useForm<IFormInputs>({
    defaultValues: {
      customerName: '',
      registrationNumber: '',
      vehicleDetails: '',
      vin: '',
    },
    mode: 'onSubmit',
    resolver: yupResolver(schema),
  });

  const onSubmit = handleSubmit(async (data) => {
    logTransaction(LogType.Info, `New adhoc job submitted`);
    data.repairOrderNumber = data.repairOrderNumber || undefined;
    await dispatch(addAdhocRepairOrderToRepairOrderSyncStoreAsync(data));
    history.replace({
      pathname: `${RouteNames.jobList}`,
      search: `repairOrderNumber=ADHOC`,
    });
  });

  return (
    <>
      <IonPageWrapper>
        <IonHeader color="lightest">
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonBackButton defaultHref={RouteNames.dashboard} color="secondary" />
            </IonButtons>
            <IonTitle>Create Adhoc Job</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => submitButtonRef?.click()}>Save</IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent color="lightest">
          <form id="clockOffLabourForm" noValidate onSubmit={onSubmit}>
            <button
              type="submit"
              className="ion-hide"
              ref={(button) => {
                if (!submitButtonRef && button) {
                  submitButtonRef = button;
                }
              }}>
              Submit
            </button>
            <IonRow>
              <IonCol className="icon-col" size="auto">
                <IonItem lines="none">
                  <IonIcon icon={person} size="small" />
                </IonItem>
              </IonCol>
              <IonCol>
                <FormInput control={control} name="customerName" placeholder="" label="Customer Name" position="floating" />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol className="icon-col" size="auto">
                <IonItem lines="none">
                  <IonIcon icon={build} size="small" />
                </IonItem>
              </IonCol>
              <IonCol>
                <FormInput control={control} name="repairOrderNumber" placeholder="" label="Repair Order Number" type="number" position="floating" />
                <FormInput control={control} name="registrationNumber" placeholder="" label="Registration Number" position="floating" />
                <FormInput control={control} name="vehicleDetails" placeholder="" label="Vehicle Details" position="floating" />
                <FormInput control={control} name="vin" placeholder="" label="VIN/Serial No" position="floating" />
              </IonCol>
            </IonRow>
          </form>
        </IonContent>
      </IonPageWrapper>
    </>
  );
};

export default AdhocClockingPage;
